import type ConnectableObject from "./ConnectableObject";
import Connection from "./Connection";

export default class AllConnections {
  validateImportExport() {
    throw new Error("Method not implemented."); // no itx
  }

  // getAllConnections(): Map<string, Connection> {
  //   const res = new Map<string, Connection>();

  //   state.floors.forEach((floor) => {
  //     floor.rooms.forEach((room) => {
  //       if (room.page) {
  //         room.page.connections.forEach((connection) => {
  //           res.set(connection.id, connection);
  //         });
  //       }
  //     });
  //   });

  //   return res;
  // }
  // // public class properties

  // // fromJSON(data: any[], parent: BaseObject): void {
  // //   data.map((item) => {
  // //     const connection = new Connection(parent);
  // //     connection.fromJSON(item);
  // //     this.items.set(connection.id, connection); // dont use add, avoid onChange-Event
  // //   });
  // // }

  // updateAllReleations(devices: Map<string, ConnectableObject>) {
  //   logger.log("updateAllReleations");
  //   const items = this.getAllConnections();
  //   items.forEach((connection) => {
  //     connection.updateRelation(devices);
  //   });
  // }

  // updateOneDevice(pageId: string, device: ConnectableObject) {
  //   logger.log("updateOneDevice");

  //   const items = this.getAllConnections();
  //   items.forEach((connection) => {
  //     connection.updateForOneConnectableObject(device);
  //   });

  //   if ((device as any).channels) {
  //     const channels = (device as any).channels as BaseModelMap<Channel>;
  //     channels.forEach((channel) => {
  //       items.forEach((connection) => {
  //         connection.updateForOneConnectableObject(channel);
  //       });
  //     });
  //   }
  // }

  highLightConnections(obj: ConnectableObject) {
    const toTop = Array<HTMLElement>();

    const items = this.getAll();
    items.forEach((connection) => {
      const elm = document.getElementById(connection.id);
      if (elm) {
        if (connection.toDevice == obj || connection.fromDevice == obj) {
          elm.setAttribute("stroke", "blue"); // no itx
          toTop.push(elm);
        } else {
          elm.setAttribute("stroke", connection.color); // no itx
        }
      }
    });

    // bring highlighted elements to top

    toTop.map((elm) => {
      const parent = elm.parentElement;
      elm.remove();
      parent?.appendChild(elm);
    });
  }

  dehighLightConnections() {
    const items = this.getAll();
    items.forEach((connection) => {
      const elm = document.getElementById(connection.id);
      if (elm) {
        elm.setAttribute("stroke", connection.color); // no itx
      }
    });
  }

  getAll() {
    const res = new Array<Connection>();
    state.floors.forEach((floor) => {
      floor.page?.connections.forEach((con) => {
        res.push(con);
      });

      floor.rooms.forEach((room) => {
        room.page?.connections.forEach((con) => {
          res.push(con);
        });
      });
    });
    return res;
  }
}
